import React from 'react';
import BlogList from './BlogList';

const Blog = () => {
    return (
        <>
            <BlogList />
        </>
    )
};

export default Blog;